// Shared chart helpers.

/**
 * Catmull-Rom → cubic-Bézier smoothing. Turns a list of {x, y} points into a
 * rounded SVG path `d` that passes through every point (no over/undershoot at
 * the ends), so straight-segment line charts read as gentle curves.
 *
 * Returns '' for an empty list and a bare "M x,y" for a single point, so the
 * curve degrades gracefully. The 1/6 factor is the standard Catmull-Rom tension.
 *
 * Points are in whatever coordinate space the caller uses (viewBox px or 0..100
 * percentages) — the math is unit-agnostic.
 */
export function smoothPath(P) {
  if (!P || !P.length) return ''
  if (P.length === 1) return `M ${P[0].x},${P[0].y}`
  let d = `M ${P[0].x},${P[0].y}`
  for (let i = 0; i < P.length - 1; i++) {
    const p0 = P[i - 1] || P[i]
    const p1 = P[i]
    const p2 = P[i + 1]
    const p3 = P[i + 2] || p2
    const cp1x = p1.x + (p2.x - p0.x) / 6
    const cp1y = p1.y + (p2.y - p0.y) / 6
    const cp2x = p2.x - (p3.x - p1.x) / 6
    const cp2y = p2.y - (p3.y - p1.y) / 6
    d += ` C ${cp1x},${cp1y} ${cp2x},${cp2y} ${p2.x},${p2.y}`
  }
  return d
}
